import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';

import { useWhatsAppLink } from '@/hooks/useWhatsAppLink';

/**
 * §60 K — desktop only. On a phone the sticky bottom bar already offers
 * WhatsApp, and two buttons for the same thing is clutter.
 *
 * It follows the page it floats over: the link carries that route's message
 * and opens that route's number (`config/whatsappContacts.ts`), so the button
 * that is always on screen is never the wrong one to press.
 */
export function FloatingWhatsApp() {
  const href = useWhatsAppLink();
  if (!href) return null;

  return (
    <Zoom in>
      <Fab
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp (opens in a new tab)"
        title="Chat with us on WhatsApp"
        sx={{
          display: { xs: 'none', md: 'inline-flex' },
          position: 'fixed',
          right: 24,
          bottom: 24,
          zIndex: (t) => t.zIndex.speedDial,
          bgcolor: 'whatsapp.main',
          color: 'whatsapp.contrastText',
          '&:hover': { bgcolor: 'whatsapp.dark' },
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Zoom>
  );
}
